import { BlockType } from '../../models';
import { formatBlockName } from '../utils';
import DefaultPreview from './previews/default-preview';
const getBlockTemplate = (blockType) => require(`./templates/${blockType}.json`);
const getBlockPreview = (blockType) => {
    try {
        return require(`./previews/${blockType}.tsx`).default;
    }
    catch (err) {
        /*eslint-disable no-console */
        console.warn(`Preview image for ${blockType} not found`);
        return DefaultPreview;
    }
};
const EditorBlocksData = Object.values(BlockType).reduce((previewData, blockType) => {
    const template = getBlockTemplate(blockType);
    const preview = getBlockPreview(blockType);
    template.meta = template.meta || {};
    template.meta.title = template.meta.title || formatBlockName(blockType);
    /* eslint-disable no-param-reassign */
    previewData[blockType] = Object.assign(Object.assign({}, template), { preview });
    return previewData;
}, {});
export default EditorBlocksData;
